import GermanEmailContent from './GermanEmailContent';
import DefaultEmailContent from './DefaultEmailContent';
import type { BenefitsProps } from './Benefits';

export type EmailContentProps = {
    requesterName: string;
    inviteeName: string;
} & BenefitsProps;

const EmailContent = ({ locale, ...props }: EmailContentProps & { locale?: string }) => {
    const localeOrDefault = locale ?? 'de-DE';

    if (localeOrDefault === 'de-DE') {
        return <GermanEmailContent {...props} />;
    }

    return <DefaultEmailContent {...props} />;
};

export default EmailContent;
